import { tenantLocationAtom } from "atoms/tenantLocationAtom.ts";
import { SectionHeader } from "components/UI/SectionHeader";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useRecoilValue } from "recoil";

import type { TitleProps } from "antd/es/typography/Title";

interface LocationSectionHeaderProps {
    level?: TitleProps["level"];
    className?: string;
}

export const LocationSectionHeader = ({ level, className }: LocationSectionHeaderProps) => {
    const { t } = usePaldockTranslation("pages");
    const tenantLocationState = useRecoilValue(tenantLocationAtom);
    return <SectionHeader title={t(`${tenantLocationState.locationTag}.title`)} level={level} className={className} />;
};
